module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/PinusPumila/Nagano_PinusPumila_MIROC5_RCP85_Mid.png";